export default function () {
  return {
    'entityType': 'EMPLOYEES',
    'employees': [],
    'roles': [],
    'jobTypes': [
      {
        'entityType': 'JOB_TYPE',
        'id': '1',
        'name': 'Cashier',
        'logOnStyle': 'SINGLE',
        'eligibleForTicketsTransfers': true,
        'defaultOrdersScreenToAssignedOrders': false,
        'printTimeClockReceiptAtClockOff': true,
        'defaultScreenAfterLogOn': 'NO_DEFAULT_SCREEN',
        'excludeFromLaborCalculations': false,
        'departmentCode': '',
        'declareTipsAtClockOff': false,
        'minimumTipPercentage': '0.00',
        'payTipsOnPayroll': false,
        'requirements': [],
        'driverSettings': {
          'mode': 'NOT_DRIVER',
          'feeMethod': 'NONE',
          'feePerOrder': '0.00',
          'feePerDispatch': '0.00',
          'orderPercentage': '0.00',
          'mileage': '0.00',
          'payFeeOnPayroll': false,
          'trackMileage': {
            'enabled': true,
            'method': 'GOOGLE_MAPS'
          },
          'zones': []
        }
      },
      {
        'entityType': 'JOB_TYPE',
        'id': '2',
        'name': 'Driver',
        'logOnStyle': 'SINGLE',
        'eligibleForTicketsTransfers': true,
        'defaultOrdersScreenToAssignedOrders': false,
        'printTimeClockReceiptAtClockOff': true,
        'defaultScreenAfterLogOn': 'NO_DEFAULT_SCREEN',
        'excludeFromLaborCalculations': false,
        'departmentCode': '',
        'declareTipsAtClockOff': false,
        'minimumTipPercentage': '0.00',
        'payTipsOnPayroll': false,
        'requirements': [],
        'driverSettings': {
          'mode': 'NOT_DRIVER',
          'feeMethod': 'NONE',
          'feePerOrder': '0.00',
          'feePerDispatch': '0.00',
          'orderPercentage': '0.00',
          'mileage': '0.00',
          'payFeeOnPayroll': false,
          'trackMileage': {
            'enabled': true,
            'method': 'GOOGLE_MAPS'
          },
          'zones': []
        }
      },
      {
        'entityType': 'JOB_TYPE',
        'id': '3',
        'name': 'Manager',
        'logOnStyle': 'SINGLE',
        'eligibleForTicketsTransfers': true,
        'defaultOrdersScreenToAssignedOrders': false,
        'printTimeClockReceiptAtClockOff': true,
        'defaultScreenAfterLogOn': 'NO_DEFAULT_SCREEN',
        'excludeFromLaborCalculations': false,
        'departmentCode': '',
        'declareTipsAtClockOff': false,
        'minimumTipPercentage': '0.00',
        'payTipsOnPayroll': false,
        'requirements': [],
        'driverSettings': {
          'mode': 'NOT_DRIVER',
          'feeMethod': 'NONE',
          'feePerOrder': '0.00',
          'feePerDispatch': '0.00',
          'orderPercentage': '0.00',
          'mileage': '0.00',
          'payFeeOnPayroll': false,
          'trackMileage': {
            'enabled': true,
            'method': 'GOOGLE_MAPS'
          },
          'zones': []
        }
      },
      {
        'entityType': 'JOB_TYPE',
        'id': '4',
        'name': 'Server',
        'logOnStyle': 'SINGLE',
        'eligibleForTicketsTransfers': true,
        'defaultOrdersScreenToAssignedOrders': false,
        'printTimeClockReceiptAtClockOff': true,
        'defaultScreenAfterLogOn': 'NO_DEFAULT_SCREEN',
        'excludeFromLaborCalculations': false,
        'departmentCode': '',
        'declareTipsAtClockOff': false,
        'minimumTipPercentage': '0.00',
        'payTipsOnPayroll': false,
        'requirements': [],
        'driverSettings': {
          'mode': 'NOT_DRIVER',
          'feeMethod': 'NONE',
          'zoneId': '',
          'feePerZone': '0.00',
          'feePerOrder': '0.00',
          'feePerDispatch': '0.00',
          'orderPercentage': '0.00',
          'mileage': '0.00',
          'payFeeOnPayroll': false,
          'trackMileage': {
            'enabled': true,
            'method': 'GOOGLE_MAPS'
          }
        }
      }
    ],
    'requirements': [
      {
        'entityType': 'JOB_TYPE_REQUIREMENT',
        'id': '1',
        'name': 'Food Handlers',
        'warnTimeBeforeExpiration': 1814400
      },
      {
        'entityType': 'JOB_TYPE_REQUIREMENT',
        'id': '2',
        'name': 'Liquor Service',
        'warnTimeBeforeExpiration': 1209600
      }
    ],
    'timeClock': {
      'enable': true,
      'autoClockOffAfterTime': 57600, // seconds
      'autoLogOffAfterTime': 300, // seconds
      'requireReasonOnEditRecords': true,
      'breaks': {
        'enabled': true,
        'defaultLength': 600, // seconds
        'isPaid': true,
        'excessIsNotPaid': true
      },
      'lunch': {
        'enabled': true,
        'defaultLength': 1800, // seconds
        'isPaid': false,
        'excessIsNotPaid': true
      }
    },
    'payrollAndOvertime': {
      'version': '1',
      'minimumWage': {
        'enabled': false,
        'amount': '0.00'
      },
      'overTimePay': {
        'after8HoursPerDay': false,
        'after40HoursPerWeek': true,
        'californiaOvertime': false
      },
      'additionalEmployerLaborCostPercentage': '0.00',
      'laborBudgetTargetPercentage': {
        0: '27.00', // Sunday
        1: '27.00',
        2: '27.00',
        3: '27.00',
        4: '27.00',
        5: '27.00',
        6: '27.00'
      },
      'salaryAllocationsPercentage': {
        0: '10.00', // Sunday
        1: '10.00',
        2: '10.00',
        3: '10.00',
        4: '10.00',
        5: '25.00',
        6: '25.00'
      }
    }
  }
}
